import './ErrorMessageBar.css';
import { useMemo } from 'react';
import { Localized } from '../../../utilities/localizedStrings';
import { getServiceErrorMessage } from '../../../services/utilities';
import { MessageBar, MessageBarType, MessageBarButton } from '@fluentui/react';

/**
 * A message bar that displays an error message and can optionally display 
 * custom text, a retry button, and a report error button 
 * 
 * @param {object} props - errorInfo, onDismiss, onRetry, reportError, customStrings 
 * @returns a MessageBar component    
 */
export const ErrorMessageBar = ({
    errorInfo,
    onDismiss,
    onRetry,
    reportError = true,
    customStrings
}) => {

    const strings = useMemo(() => {
        return {
            dismissButtonLabel: Localized.get('close'),
            headingLabel: Localized.get('errorMessageBar-heading'),
            retryLabel: Localized.get('retry'),
            ...customStrings
        };
    }, [customStrings]);

    if (!errorInfo) {
        return null;
    }

    const errorMessage = getServiceErrorMessage(errorInfo);

    return (
        <MessageBar
            className="cw-ErrorMessageBar"
            messageBarType={MessageBarType.error}
            truncated
            onDismiss={onDismiss}
            dismissButtonAriaLabel={strings.dismissButtonLabel}
            actions={
                <div>
                    {onRetry ?
                        <MessageBarButton
                            onClick={onRetry}
                        >{strings.retryLabel}</MessageBarButton>
                        :
                        null
                    }
                    {reportError ?
                        <MessageBarButton>
                            TODO: Report Error
                        </MessageBarButton>
                        :
                        null
                    }
                </div>
            }
        >
            <div>
                <h4>{strings.headingLabel}</h4>
                {errorMessage?.message}
            </div>
        </MessageBar>
    );
}
